/**
 * @file 申诉反馈
 * @author zhaomiaoyuan
 */
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter, Prompt} from 'react-router-dom';
import StepsMenu from '../../components/StepsMenu/index';
import Step1 from './step1.jsx';
import Step2 from './step2.jsx';
import Step3 from './step3.jsx';
// import {initCaptcha} from '../../../src/constants/utils';
import {
    fetchAppealSearch,
    updateAppeal,
    cleanAppeal,
    appealSubmit,
} from '../../actions/appealAction';

import {
    fetchSendCode,
    fetchUserInfo
} from '../../actions/attestAction';

import {recordProxy, bCat_2055_request, getQueryString, handleLogin} from '../../util';
import {STEP_LIST} from './conf';

interface IAppealMajorProps {
    appealData: any;
    fetchAppealSearch: typeof fetchAppealSearch;
    updateAppeal: typeof updateAppeal;
    cleanAppeal: typeof cleanAppeal;
    fetchUserInfo: typeof fetchUserInfo;
}
export function AppealMajor(props: IAppealMajorProps) {
    const {
        appealData,
        updateAppeal,
        fetchAppealSearch,
        fetchUserInfo,
        cleanAppeal,
    } = props;

    useEffect(() => {
        let pagef = 'nopagef';
        const queryPhones = getQueryString('phones'); // 号码报错-阿拉丁卡片点击
        const queryPhone = getQueryString('phone'); // 标记错误-阿拉丁卡片点击
        const querySrcid = getQueryString('srcid'); // aladin卡片来源
        const queryPagef = getQueryString('pagef'); // 网页内部来源
        // pagef参数为网页内部来源，srcid为阿拉丁卡片来源
        if (queryPagef || querySrcid) {
            pagef = queryPagef || querySrcid;
        } else if (!querySrcid && (queryPhones || queryPhone)) {
            // 阿拉丁卡片8757-标记错误/号码报错入口没有带srcid，先暂时这样处理。后续等pc端阿拉丁卡片加上srcid就可以删去
            pagef = '8757';
        }
        const param = {
            dataUrl: location.pathname,
            pagef
        };
        recordProxy('appeal-feedback-page', 'enter', JSON.stringify(param));
    }, [location.pathname, getQueryString('pagef')]);
    useEffect(() => {
        window.scrollTo(0, 0);
        handleLogin(fetchUserInfo);
        cleanAppeal();
        return () => {
            cleanAppeal();
        };
    }, [location.pathname]);
    useEffect(() => {
        const queryPhones = getQueryString('phones');
        const queryPhone = getQueryString('phone');
        const srcid = getQueryString('srcid');
        const entity = getQueryString('entity');
        let searchUrl = '';
        if (queryPhones) {
            searchUrl = queryPhones;
        } else if (queryPhone) {
            searchUrl = encodeURIComponent(JSON.stringify([{phone: queryPhone}]));
        }
        let phoneListTemp = [] as any;
        // 8952资源存在多个号码相同的情况，直接显示输入框
        if (searchUrl && srcid !== '8952') {
            try {
                phoneListTemp = JSON.parse(decodeURIComponent(searchUrl));
                if (entity === '1' && phoneListTemp && phoneListTemp.length > 1 && srcid === '55430') {
                    return;
                }
                updateAppeal({
                    phoneList: phoneListTemp,
                    hasSearchUrl: !!searchUrl.length
                });
                searchFn({
                    phone: phoneListTemp[0].phone,
                    // phoneName: phoneListTemp[0].name,
                    hasSearchUrl: !!searchUrl.length,
                });
            } catch (e) {
                console.log(e);
            }
        }

    }, [location.search, getQueryString]);

    const nonempty = () => {
        if (appealData.curStep === 3) {
            return false;
        }

        return appealData.phone !== ''
            || appealData.phoneName !== ''
            || appealData.companyName !== ''
            || appealData.cert.length > 0
            || appealData.companyQualify.length > 0
            || appealData.social.length > 0
            || appealData.companyAddress !== ''
            || appealData.nameGov !== ''
            || appealData.email !== ''
            || appealData.emailCode !== ''
            || appealData.isRead;
    };
    // const getPhoneName = data => {
    //     if (!data) {
    //         return '';
    //     }
    //     const dataInfo = data?.list[0];
    //     let phoneName = '';
    //     switch(data.mode) {
    //         case 'customer':
    //             phoneName = dataInfo.key || dataInfo.title;
    //             break;
    //         case 'reports':
    //             phoneName = dataInfo.tag;
    //             break;
    //         case 'poi':
    //             phoneName = dataInfo.name;
    //             break;
    //     }
    //     return phoneName;
    // };
    // const getOccupyTitle = (data) => {
    //     if (data.mode === 'customer') {
    //         return data.list.find(item => item.title)?.title;
    //     } else if (data.mode === 'poi') {
    //         return data.list.find(item => item.name)?.name;
    //     }
    //     return '';
    // };
    const searchFn = (data) => {
        recordProxy('appeal-feedback', 'click', 'search');
        const fetchAppealSearchFn = (params) => fetchAppealSearch({
            ...params,
            search: data.phone.replace(/\s+/g, ''),
        }).then(res => {
            if (res?.code === 200 && res?.data.mode) {
                const mode = res.data.mode;
                let phoneNum = data.phone;
                updateAppeal({
                    phone: phoneNum.replace(/\s+/g, ''),

                    phoneErr: '',
                    curStep: 2,
                    phoneMode: mode,
                    reportTag: '',
                    questionType: mode === 'reports' ? 6 : 1, // 如果是标记错误，默认选中
                });
                window.scrollTo(0, 0);
            } else if (res.code === 200 && !res.data.mode) {
                updateAppeal({
                    phone: data.phone,
                    phoneErr: '该号码目前未被标记，无需申诉'
                });
            } else {
                updateAppeal({
                    phone: data.phone,
                    phoneErr: res?.message
                });
            }
        });
        bCat_2055_request(fetchAppealSearchFn);
    };
    return (<div className="appeal-major">
        <div className="banner">
            <div className={'carousel-item appeal-feedback-banner'}>
                <div className="item-info-wrapper">
                    <p className="title">号码申诉反馈</p>
                    <p className="title-tip">号码错误、占用、空号等问题申诉及反馈</p>
                </div>
            </div>
            <div className="banner-bottom"></div>
        </div>

        <div className="steps-menu">
            <StepsMenu data={STEP_LIST} curStep={appealData.curStep} />
        </div>

        <div className="appeal-major-content">
            {appealData.curStep === 1 && <Step1 {...props} searchFn={searchFn} />}
            {appealData.curStep === 2 && <Step2 {...props} />}
            {appealData.curStep === 3 && <Step3 {...props} />}
        </div>
        <Prompt
            when={nonempty()}
            message={() => {
                return  '是否不提交信息进行跳转？';
            }}
        />
    </div>);
}

function mapStateToProps(state) {

    return {
        appealData: state.appealReducer
    };
}
function mapDispatchToProps(dispatch) {
    return {
        fetchAppealSearch: obj => fetchAppealSearch(dispatch, obj),
        fetchSendCode: obj => fetchSendCode(dispatch, obj),
        updateAppeal: obj => updateAppeal(dispatch, obj),
        cleanAppeal: () => cleanAppeal(dispatch),
        fetchUserInfo: () => fetchUserInfo(dispatch),
        appealSubmit: obj => appealSubmit(dispatch, obj)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppealMajor as any));
